
import React, {Component} from 'react';
import {connect} from 'react-redux'
import GeneralDoc from './CreditDebitNoteDoc'
class CreditNoteDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {data:{doc:{},itemlist:[]}}
  }

  componentDidMount(){
    
  }

  componentWillMount() {
    // Instantiate a Realtime client 
  }

  loadNewDoc(callback) {
    
    this.refs.genDoc.getWrappedInstance().loadNewDoc((result)=>{
      if (callback!==undefined)
        callback(result.creditnote_no)
      
    },)
  }

  loadData(docNo) {
    this.refs.genDoc.getWrappedInstance().loadData(docNo)
  }

  setDataFromTaxinvoice(data,taxinvoice_no,bill_no) {
    this.refs.genDoc.getWrappedInstance().setDataFromTaxinvoice(data,taxinvoice_no,bill_no)
  }

  renameDoc() {
    
  }

  onDocClose() {
    if (this.props.onClose!==undefined)
      this.props.onClose()
  }

  render() {
    return(
      <GeneralDoc
        ref={'genDoc'}
        title={this.props.title} 
        docType={this.props.docType}
        docSName={this.props.docSName}
        docName={this.props.docName}
        showDiscount={false}
        onLoadData={(data)=>{
          this.setState({data:data})
        }}
        onClose={this.onDocClose.bind(this)}
      />
    )
  }
}

export default CreditNoteDoc = connect(
  (state) => ({messages: state.message.view.doc.DeliverySlipDoc}),null,null,{withRef:true}
)(CreditNoteDoc);





// WEBPACK FOOTER //
// ./src/view/doc/CreditNoteDoc.js